import React from "react"
import { Loader } from "shared/ui/Loader/Loader.component"
import OutputTabs from "./OutputTabs.component"
import { EngineQueryResult } from "types/engineOutput.types"

// Define the props interface for the Output component
interface OutputProps {
  /** The output content to display */
  result: EngineQueryResult
  /** Indicates whether the script is running */
  scriptInProgress: boolean
  /** Indicates whether the async script is running */
  asyncScriptInProgress: boolean
}

/**
 * Component for displaying the output.
 *
 * This component renders a title and the output content passed as a prop.
 *
 * @param props - The component props
 * @returns {JSX.Element} The rendered output component.
 */
const Output: React.FC<OutputProps> = ({
  result,
  scriptInProgress,
  asyncScriptInProgress,
}) => {
  return (
    <div className="flex flex-col h-full border-t border-l-0 border-r-0 border-b-0 rounded-br-xl overflow-hidden">
      {scriptInProgress || asyncScriptInProgress ? (
        <div className="flex flex-col items-center justify-center h-full">
          <Loader fontSize={48} />
          {asyncScriptInProgress
            ? "Just a moment, your script is running..."
            : "Script is running..."}
        </div>
      ) : (
        <>
          {result?.result && (
            <div className="flex flex-col h-full">
              <div className="flex-grow overflow-auto">
                <OutputTabs result={result.result} />
              </div>
              <div className="flex flex-row w-full p-2 rounded-br-xl bg-white">
                {result.result.log ? (
                  <p
                    className="font-semibold truncate"
                    title={result.result.log[result.result.log.length - 1]}
                  >
                    Log: {result.result.log[result.result.log.length - 1]}
                  </p>
                ) : (
                  <p className="font-semibold">Log: No log available</p>
                )}
                {result.Time && (
                  <p className="ml-auto whitespace-nowrap">
                    Time Taken:{" "}
                    <span className="italic text-[var(--dq-brand)]">
                      {result.Time.toString()}s
                    </span>
                  </p>
                )}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default Output
